import * as React from 'react';
import { ContainerPagination, List, PaginationButton } from './style';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

interface IPaginationProps {
  count: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  page: number;
}

export default function UsePagination({
  count,
  onChange,
  page,
}: IPaginationProps) {
  const handleClick = (newPage: number) => {
    onChange({} as React.ChangeEvent<unknown>, newPage);
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 4;
    
    if (count <= maxVisible) {
      for (let i = 1; i <= count; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 2) {
        for (let i = 1; i <= maxVisible; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(count);
      } else if (page >= count - 1) {
        pages.push(1);
        pages.push('...');
        for (let i = count - (maxVisible - 1); i <= count; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = page - 1; i <= page + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(count);
      }
    }

    return pages;
  };

  return (
    <ContainerPagination>
      <nav>
        <List>
          <li>
            <PaginationButton
              type="button"
              disabled={page === 1}
              onClick={() => handleClick(page - 1)}
              title="Página anterior"
              aria-label="Página anterior"
            >
              <ChevronLeft sx={{ fontSize: 20 }} />
            </PaginationButton>
          </li>
          
          {renderPageNumbers().map((item, index) => (
            <li key={typeof item === 'string' ? `dots-${index}` : item}>
              <PaginationButton
                type="button"
                onClick={() => typeof item === 'number' && handleClick(item)}
                disabled={item === '...'}
                aria-label={`Ir para página ${item}`}
                title={`Ir para página ${item}`}
                aria-current={item === page ? 'true' : 'false'}
              >
                {item}
              </PaginationButton>
            </li>
          ))}

          <li>
            <PaginationButton
              type="button"
              disabled={page === count}
              onClick={() => handleClick(page + 1)}
              title="Próxima página"
              aria-label="Próxima página"
            >
              <ChevronRight sx={{ fontSize: 20 }} />
            </PaginationButton>
          </li>
        </List>
      </nav>
    </ContainerPagination>
  );
}
